export default {
      id: "icon-mutfak-usage",
      viewBox: "0 0 507.4 507.4",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-mutfak",
      toString: function () {
        return this.url;
      }
    }